module.exports = __webpack_public_path__ + "static/media/108.2a78010a.jpg";